import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import _, { uniqBy } from 'lodash';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SegmentsService = /** @class */ (function () {
    function SegmentsService(http) {
        this.http = http;
        this.apiEndPoint = '/dashboard/segments';
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    SegmentsService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    SegmentsService.prototype.upsertSegment = function (params) {
        var endPoint = this.apiEndPoint + '/v1/seg';
        return this.http.post(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    /**
     * Update or Create a new segment.
     * Parameter segmentId is optional, API will try to create if segmentId is missing.
     *  */
    SegmentsService.prototype.upsertSegmentWithParams = function (appId, name, desc, criteria, isDIL, segmentId) {
        var params = {
            name: name,
            app_id: appId,
            desc: desc,
            criteria: criteria,
            dil: isDIL
        };
        if (segmentId) {
            params['segment_id'] = segmentId;
        }
        return this.upsertSegment(params);
    };
    SegmentsService.prototype.duplicateSegment = function (appId, segId, name, desc) {
        var endPoint = this.apiEndPoint + '/v1/seg/duplicate';
        var params = {
            app_id: appId,
            segment_id: segId,
            new_segment_name: name,
            desc: desc
        };
        return this.http.post(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    SegmentsService.prototype.upsertNewSubsegments = function (appId, segmentId, criteria, isDIL) {
        var params = {
            app_id: appId,
            criteria: criteria,
            dil: isDIL,
            segment_id: segmentId
        };
        return this.upsertSegment(params);
    };
    /**
     * Get segment details of a list of segmentIds
     *
     * @param   string          appId       application Id
     * @param   Array[string]   segmentIds  list of segmentIds
     *
     */
    SegmentsService.prototype.getSegmentsById = function (appId, segmentIds) {
        var dataParams = {
            'aid': appId,
            'ids': segmentIds
        };
        return this.getSegments(dataParams);
    };
    /**
     * Fetch list of segments for selected appId
     *
     * @param   string  appId   application Id
     * @param   number  offset  page offset
     * @param   number  limit   page item count
     *
     */
    SegmentsService.prototype.getSegmentsList = function (appId, offset, limit) {
        var dataParams = {
            'aid': appId,
            'o': offset,
            'l': limit
        };
        return this.getSegments(dataParams);
    };
    SegmentsService.prototype.getSegments = function (params) {
        var endPoint = this.apiEndPoint + '/v1/seg';
        var dataToSend = { 'params': params };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    /**
     * Query segments
     */
    SegmentsService.prototype.searchSegmentsList = function (query, appId, offset, limit) {
        var endPoint = this.apiEndPoint + '/v1/search';
        var dataParams = {
            'aid': appId,
            'q': query,
            'o': offset,
            'l': limit
        };
        var dataToSend = { 'params': dataParams };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    /**
     * Delete selected segment by segment Id
     *
     * @param   string   appId       application Id
     * @param   string   segmentIds  segmentId to delete
     */
    SegmentsService.prototype.deleteSegment = function (appId, segmentId) {
        var endPoint = this.apiEndPoint + '/v1/del';
        var dataToSend = {
            'params': {
                'aid': appId,
                'ids': [segmentId]
            }
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    SegmentsService.prototype.getDilSegmentProgress = function (appId) {
        var endPoint = '/dashboard/ujmanalytics/dil/segment/status/' + appId;
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions)).pipe(map(this.extractData));
    };
    /**
     * Search events for current app Id with matching Name or vendor
     *
     */
    SegmentsService.prototype.getEvents = function (appId, offset, limit, vendor, ipa_only, q) {
        var url = '/dashboard/event/v1/' + appId + '?o=' + offset + '&l=' + limit + '&t=0';
        if (!offset && !limit) {
            url = '/dashboard/event/v1/' + appId + '?t=0';
        }
        url += (q && q !== '') ? '&q=' + q : '';
        url += vendor ? '&v=' + vendor : '';
        url += ipa_only ? '&ipa_only=true' : '';
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    SegmentsService.prototype.getSMTEventNameMap = function () {
        var url = "https://cdnt.netcoresmartech.com/system_activity.json";
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    /**
     * update IPA events for current app Id with matching Name or vendor
     *
     * payload:
        {
          "attach_evt_list": [
              “5c94b0200e680b9137a6bb94”
            ],
          “detach_evt_list”: [
              “5c94b9137a6bb940200e680b”
            ]
        }
     */
    SegmentsService.prototype.setIPAEvents = function (appId, vendor, payload) {
        var url = '/dashboard/event/v1/' + appId + '/ipa';
        if (vendor) {
            payload['v'] = vendor;
        }
        return this.http.post(url, payload, this.httpOptions).pipe(map(this.extractData));
    };
    /**
     * Search segments for current app Id for matching Name or desc
     *
     * @param   string  appId   application id
     * @param   string  query   query string to search for
     * @param   number  offset  page offset
     * @param   number  limit   page size
     *
     */
    SegmentsService.prototype.searchSegments = function (appId, query, offset, limit) {
        var endPoint = this.apiEndPoint + '/v1/search';
        var dataToSend = {
            'params': {
                'aid': appId,
                'q': query,
                'o': offset,
                'l': limit
            }
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    SegmentsService.prototype.categorizeEvents = function (events, hideEventCategory) {
        if (hideEventCategory === void 0) { hideEventCategory = {}; }
        var eventCategoryMap = events.reduce(function (acc, event) {
            if (hideEventCategory.hasOwnProperty(event.ven)) {
                return acc;
            }
            var vendor = event.ven;
            if (!event.ven) {
                vendor = 'misc';
            }
            if (!acc.hasOwnProperty(vendor)) {
                acc[vendor] = [];
            }
            acc[vendor].push(event);
            return acc;
        }, {});
        Object.keys(eventCategoryMap).forEach(function (vendor) {
            eventCategoryMap[vendor] = uniqBy(eventCategoryMap[vendor], 'name');
        });
        return eventCategoryMap;
    };
    SegmentsService.prototype.getCategoriesMap = function () {
        return {
            mxp: 'Mixpanel',
            ctp: 'Clevertap',
            amp: 'Amplitude',
            ga: 'Google Analytics',
            smt: 'Smartech Events',
            fbs: 'Firebase',
            omni: 'Omniture',
            loca: 'Localytics',
            wbe: 'Webengage',
            hsl: 'Hansel Events',
            sgmt: 'Segment',
            dthw: 'Data Highway',
            apfr: 'AppsFlyer',
            adobe: 'Adobe'
        };
    };
    SegmentsService.prototype.updateAttachEventListForSegments = function (appId, segmentList, data) {
        var _this = this;
        if (data[0].is_error || data[1].is_error) {
            return;
        }
        var ipaEvents = data[0].api_response.events.reduce(function (acc, cur) {
            acc[cur.id] = cur;
            return acc;
        }, {});
        var promiseArr = [];
        segmentList.forEach(function (segment) {
            var completeEventList = data[1].api_response.events;
            var finalAttachedEvents = _this.getAttachedEvents(segment, completeEventList);
            var remainingEvents = [];
            var finalEventsId = Object.keys(finalAttachedEvents);
            finalEventsId.forEach(function (eventId) {
                if (ipaEvents.hasOwnProperty(eventId)) {
                    return;
                }
                remainingEvents.push(finalAttachedEvents[eventId]);
            });
            if (!remainingEvents.length) {
                return;
            }
            promiseArr = promiseArr.concat(_this.getSetIPAPromises(appId, remainingEvents));
        });
        return forkJoin(promiseArr)
            .subscribe(function (ipaSetResponse) {
            // console.log('data!', ipaSetResponse);
        });
    };
    SegmentsService.prototype.getSetIPAPromises = function (appId, events) {
        var _this = this;
        var attach_evt_list = events;
        var detach_evt_list = [];
        attach_evt_list = _.groupBy(attach_evt_list, function (ev) {
            return ev.pi;
        });
        var ipaPromises = [];
        Object.keys(attach_evt_list).forEach(function (ven) {
            var promise = _this.setIPAEvents(appId, ven, {
                'attach_evt_list': (attach_evt_list[ven] || []).map(_.property('event_id')),
                'detach_evt_list': (detach_evt_list[ven] || []).map(_.property('event_id'))
            });
            ipaPromises.push(promise);
        });
        return ipaPromises;
    };
    SegmentsService.prototype.getAttachedEvents = function (segmentData, completeEventList) {
        var _this = this;
        var eventList = {};
        if (!(segmentData && segmentData.criteria && segmentData.criteria.rules)) {
            return;
        }
        segmentData.criteria.rules.forEach(function (rule) {
            if (rule.hasOwnProperty('n') && rule['n'] !== 'hansel_nudge_event' && rule['n'] !== '_hsl_page_load') {
                var eventObject = _this.getEventIdForRule(rule, completeEventList);
                if (!eventObject) {
                    return;
                }
                var ruleClone = _.cloneDeep(rule);
                ruleClone.event_id = eventObject.id;
                eventList[eventObject.id] = ruleClone;
            }
        });
        return eventList;
    };
    SegmentsService.prototype.getEventIdForRule = function (rule, eventList) {
        return eventList.filter(function (event) { return event.ven === rule.pi && event.name === rule.n; })[0];
    };
    SegmentsService.prototype.fetchAllEvents = function (appId, offset, limit, vendor, ipa_only) {
        var _this = this;
        var eventList = [];
        return new Observable(function (observer) {
            var fetchEvents = function (o) {
                _this.getEvents(appId, o, limit, vendor, ipa_only).subscribe(function (res) {
                    if (!res['is_error']) {
                        eventList.push.apply(eventList, res['api_response']['events']);
                        var tc = res['api_response']['total_count'];
                        if (tc > eventList.length) {
                            return fetchEvents(eventList.length);
                        }
                    }
                    res['api_response']['events'] = eventList;
                    observer.next(res);
                    observer.complete();
                });
            };
            fetchEvents(offset);
        });
    };
    SegmentsService.ngInjectableDef = i0.defineInjectable({ factory: function SegmentsService_Factory() { return new SegmentsService(i0.inject(i1.HttpClient)); }, token: SegmentsService, providedIn: "root" });
    return SegmentsService;
}());
export { SegmentsService };
